import React, { useEffect, useState } from "react";
import { Card, Form, Image, Row, Col, Modal, Button } from "react-bootstrap";
import "./ClothPriceStep1.css"; // ✅ use the same CSS
import { useNavigate, useParams } from "react-router-dom";
import { handleGetClothType_list } from "./orderModel";
import { getImageUrl } from "../../../../MIS/Global";
import noImage from "../../../../Assets/No_Image_Available.jpg";
import { FaExclamationCircle } from "react-icons/fa";

const defaultImage = noImage;

const ClothType = ({
  selectedCloth,
  selectedClothType,
  setSelectedClothType,
  quote,
}) => {
  const { id, subid } = useParams();
  const navigate = useNavigate();
  const [clothOptions, setClothOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalImage, setModalImage] = useState(null);

  const handleImageClick = (img) => setModalImage(img);
  const handleClose = () => setModalImage(null);

  useEffect(() => {
    handleGetClothType_list({ setLoading, setClothOptions, selectedCloth });
  }, []);

  useEffect(() => {
    if (quote?.length > 0) {
      if (clothOptions?.length > 0) {
        const result = clothOptions?.find(
          (item) => item.id === quote?.[0]?.cloth_id
        );
        setSelectedClothType(result);
      }
    }
  }, [quote, clothOptions]);

  return (
    <>
      {!selectedCloth && (
        <div
          className="text-danger d-flex align-items-center mt-2 p-2 rounded"
          style={{ backgroundColor: "#ffe6e6", fontSize: "0.9rem" }}
        >
          <FaExclamationCircle className="me-2" />
          Please select a print type to continue.
        </div>
      )}

      <div className="cloth-list-wrapper">
        {loading ? (
          <div className="text-center my-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <Row className="g-2 g-sm-3">
            {clothOptions.map((item) => (
              <Col xs={6} sm={6} md={4} className="mb-2" key={item.id}>
                <Card
                  className={`cloth-card product-card h-100 ${
                    selectedClothType?.id === item.id ? "selected" : ""
                  } ${quote?.length > 0 ? "disabled" : ""}`}
                  onClick={() => setSelectedClothType(item)}
                >
                  <Card.Body className="p-2 text-center">
                    <div className="position-relative">
                      <Form.Check
                        type="radio"
                        id={item.id}
                        name="clothId"
                        value={item.id}
                        checked={selectedClothType?.id === item.id}
                        onChange={() => setSelectedClothType(item)}
                        className="cloth-radio"
                      />
                      <Image
                        src={getImageUrl(item?.imgpath)}
                        rounded
                        className="cloth-image-large"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleImageClick(getImageUrl(item?.imgpath));
                        }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = defaultImage;
                        }}
                      />
                    </div>
                    <div className="cloth-label mt-2 small fw-semibold">
                      {item?.cloth_name}
                    </div>
                    <div className="text-muted small fw-bold">
                      ₹{Number(item?.sub_price).toFixed(2)}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </div>

      <Modal show={!!modalImage} onHide={handleClose} centered>
        <Button
          variant="light"
          onClick={handleClose}
          className="modal-close-btn"
        >
          &times;
        </Button>
        <Modal.Body className="p-0 text-center modal-image-body">
          <Image src={modalImage} className="modal-image" />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ClothType;
